<div class="container-fluid">
  <section>
        <div class="row d-flex gap-2 mt-2">
          &nbsp;<mat-form-field appearance="outline" class="col-md-3">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
            <input matEndDate [(ngModel)]="endDate" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

        </mat-form-field>
          <app-searchable-select
            class="col-md-3"
            [options]="centres$ | async"
            [multiple]="true"
            [hideSelectAllOption]="false"
            [displayKey]="'centreName'"
            [valueKey]="'centreCode'"
            [label]="'Select Centre'"
            [placeholder]="'All Centres'"
            [selectedValue]="selectedCentres"
            (selectionChange)="onCentresSelected($event)">
          </app-searchable-select>
          <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Submitted By</mat-label>
            <mat-select [(ngModel)]="submittedBy" (selectionChange)="applyfilters()">
              <mat-option [value]=null> All Counsellors</mat-option>
              <mat-option *ngFor="let e of counsellors$|async" [value]="e.userName">{{ e.userName }}</mat-option>
            </mat-select>
          </mat-form-field>
           <button mat-mini-fab (click)="search()" color="accent">
             <mat-icon>search</mat-icon>
           </button>
           <button mat-mini-fab (click)="clearAll()" color="accent">
             <mat-icon>clear</mat-icon>
           </button>
        </div>
  </section>


  <div class="card p-2">

    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Follow Up Assessment </h2>
        </li>
        <li class="dropdown m-l-20">
          <label id="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li class="me-2">
          <button mat-mini-fab color="primary" permission="Follow Up Assessments"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
            <mat-icon class="col-white"  (click)="OpenDialog()">add</mat-icon>
          </button>
        </li>

        <li>
          <button
            mat-mini-fab color="accent"
            (click)="downloadExcel()">
            <mat-icon>download</mat-icon>
          </button>
        </li>
        <!--      <li>-->
        <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
        <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
        <!--        </div>-->
        <!--      </li>-->
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading...</mat-progress-bar>

    <table mat-table [dataSource]="dataSource" class="  example-container">

      <!--- Note that these columns can be defined in any order.
      <!--- Note that these columns can be defined in any order.e
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="sr.no">
        <th mat-header-cell *matHeaderCellDef> Sr.No.</th>
        <td mat-cell *matCellDef="let element; let i=index"> {{ i+1 }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="children">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.childName }}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef> Centre</th>
        <td mat-cell *matCellDef="let element">{{ element.centreName }}</td>
      </ng-container>
      <!-- Weight Column -->
      <ng-container matColumnDef="sessionType">
        <th mat-header-cell *matHeaderCellDef> Assessment No</th>
        <td mat-cell *matCellDef="let element">{{ element.sessionType }}</td>
      </ng-container>

      <ng-container matColumnDef="dateOfAssessment">
        <th mat-header-cell *matHeaderCellDef> Assessment Date</th>
        <td mat-cell *matCellDef="let element">{{ element.dateOfAssessment.toDate() | date :'dd/MM/yyyy' }}</td>
      </ng-container>
      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef>Submitted By</th>
        <td mat-cell *matCellDef="let element">{{ element.submittedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="accent" permission="Follow Up Assessments"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]"
                  matTooltip="View" (click)="viewDialog(element)">
            <mat-icon>remove_red_eye</mat-icon>
          </button>
          <button *ngIf="editAccess(element)" mat-icon-button color="primary" permission="Follow Up Assessments"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]"
                  (click)="viewEdit(element)" matTooltip="Edit">
            <mat-icon>edit </mat-icon>
          </button>
          <button mat-icon-button color="warn" *ngIf="username=='Krisha Shah'" (click)="deleteChild(element)"
                  matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>

        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"

                   aria-label="Select page">
    </mat-paginator>
  </div>
</div>
